"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.enhance = exports["default"] = exports.Calendar = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _defaultProps = _interopRequireDefault(require("recompose/defaultProps"));

var _withStateHandlers = _interopRequireDefault(require("recompose/withStateHandlers"));

var _is_before = _interopRequireDefault(require("date-fns/is_before"));

var _sub_months = _interopRequireDefault(require("date-fns/sub_months"));

var _add_months = _interopRequireDefault(require("date-fns/add_months"));

var _add_weeks = _interopRequireDefault(require("date-fns/add_weeks"));

var _start_of_month = _interopRequireDefault(require("date-fns/start_of_month"));

var _end_of_month = _interopRequireDefault(require("date-fns/end_of_month"));

var _start_of_week = _interopRequireDefault(require("date-fns/start_of_week"));

var _end_of_week = _interopRequireDefault(require("date-fns/end_of_week"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _CalendarWeek = _interopRequireDefault(require("./CalendarWeek"));

var _CalendarHeader = _interopRequireDefault(require("./CalendarHeader"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var enhance = (0, _compose["default"])((0, _defaultProps["default"])({
  today: new Date()
}), (0, _withStateHandlers["default"])(function (_ref) {
  var selectedDate = _ref.selectedDate,
      today = _ref.today;
  return {
    calendarStart: selectedDate || today
  };
}, {
  previousMonth: function previousMonth(_ref2) {
    var calendarStart = _ref2.calendarStart;
    return function () {
      return {
        calendarStart: (0, _sub_months["default"])(calendarStart, 1)
      };
    };
  },
  nextMonth: function nextMonth(_ref3) {
    var calendarStart = _ref3.calendarStart;
    return function () {
      return {
        calendarStart: (0, _add_months["default"])(calendarStart, 1)
      };
    };
  }
}));
exports.enhance = enhance;

var Calendar = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(Calendar, _PureComponent);

  function Calendar() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Calendar.prototype;

  _proto.renderWeeks = function renderWeeks() {
    var _this$props = this.props,
        allValid = _this$props.allValid,
        calendarStart = _this$props.calendarStart,
        reservationWindow = _this$props.reservationWindow,
        closures = _this$props.closures,
        onDateClick = _this$props.onDateClick,
        selectedDate = _this$props.selectedDate;
    var weekStart = (0, _start_of_week["default"])((0, _start_of_month["default"])(calendarStart));
    var lastDate = (0, _end_of_week["default"])((0, _end_of_month["default"])(calendarStart));
    var weeks = [];

    while ((0, _is_before["default"])(weekStart, lastDate)) {
      weeks.push( /*#__PURE__*/_react["default"].createElement(_CalendarWeek["default"], {
        key: (0, _format["default"])(weekStart, 'YYMD'),
        start: weekStart,
        resWindow: reservationWindow,
        closures: closures,
        onDateClick: onDateClick,
        currentMonth: (0, _start_of_month["default"])(calendarStart),
        selectedDate: selectedDate,
        allValid: allValid
      }));
      weekStart = (0, _add_weeks["default"])(weekStart, 1);
    }

    return weeks;
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.props.getRef,
      className: this.props.className
    }, /*#__PURE__*/_react["default"].createElement(this.props.headerComponent, {
      month: this.props.calendarStart,
      onPreviousClick: this.props.previousMonth,
      onNextClick: this.props.nextMonth,
      headerLabel: this.props.headerLabel,
      today: this.props.today,
      allValid: this.props.allValid
    }), /*#__PURE__*/_react["default"].createElement("table", {
      className: "calendar-body"
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
      className: "calendar-week"
    }, /*#__PURE__*/_react["default"].createElement("th", {
      key: "sun"
    }, "Su"), /*#__PURE__*/_react["default"].createElement("th", {
      key: "mon"
    }, "Mo"), /*#__PURE__*/_react["default"].createElement("th", {
      key: "tue"
    }, "Tu"), /*#__PURE__*/_react["default"].createElement("th", {
      key: "wed"
    }, "We"), /*#__PURE__*/_react["default"].createElement("th", {
      key: "thu"
    }, "Th"), /*#__PURE__*/_react["default"].createElement("th", {
      key: "fri"
    }, "Fr"), /*#__PURE__*/_react["default"].createElement("th", {
      key: "sat"
    }, "Sa"))), /*#__PURE__*/_react["default"].createElement("tbody", null, this.renderWeeks())), this.props.children);
  };

  return Calendar;
}(_react.PureComponent);

exports.Calendar = Calendar;
Calendar.propTypes = {
  today: _propTypes["default"].instanceOf(Date),
  calendarStart: _propTypes["default"].instanceOf(Date),
  selectedDate: _propTypes["default"].instanceOf(Date),
  previousMonth: _propTypes["default"].func.isRequired,
  nextMonth: _propTypes["default"].func.isRequired,
  closures: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date)),
  reservationWindow: _propTypes["default"].instanceOf(Date),
  headerComponent: _propTypes["default"].func,
  getRef: _propTypes["default"].func,
  headerLabel: _propTypes["default"].node,
  onDateClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  allValid: _propTypes["default"].bool
};
Calendar.defaultProps = {
  closures: [],
  headerComponent: _CalendarHeader["default"]
};

var _default = enhance(Calendar);

exports["default"] = _default;